<template>
  <div>
    <!-- Create a mobile view vs a desktop view -->
    <v-parallax
      v-show="$vuetify.breakpoint.smAndDown"
      dark
      src="/img/working_on_business.jpg"
    >
      <v-row align="center">
        <v-col cols="12" md="6">
          <v-sheet class="transparent pa-6">
            <p class="text-h5 white--text">
              The demand for greater value and accountability in healthcare is fundamentally changing the competitive landscape.
            </p>
            <p class="subheading white--text">
              If you’re seeking a partner with strong experience in sales/marketing and operational expertise, as well as capital, let's talk.
            </p>
            <div class="text-center">
              <v-btn text large class="white success--text text-h5" rounded to="/contact">
                <v-icon left>
                  email
                </v-icon>
                Contact Us
              </v-btn>
            </div>
          </v-sheet>
        </v-col>
      </v-row>
    </v-parallax>
    <v-parallax
      v-show="$vuetify.breakpoint.mdAndUp"
      dark
      src="/img/working_on_business.jpg"
    >
      <v-row align="center">
        <v-col cols="12" md="6">
          <v-sheet class="transparent pa-6">
            <p class="text-h3 white--text">
              The demand for greater value and accountability in healthcare is fundamentally changing the competitive
              landscape.
            </p>
          </v-sheet>
        </v-col>
        <v-col v-show="$vuetify.breakpoint.mdAndUp">
          <v-card class="mx-auto" color="success" dark max-width="450">
            <v-card-text class="text-h4">
              If you’re seeking a partner with strong experience in sales/marketing and operational expertise, as well as capital, let’s talk.
            </v-card-text>
            <v-card-actions class="pb-6">
              <v-spacer />
              <v-btn text x-large class="white success--text" rounded to="/contact">
                <v-icon left>
                  email
                </v-icon>
                Contact Us
              </v-btn>
              <v-spacer />
            </v-card-actions>
          </v-card>
        </v-col>
      </v-row>
    </v-parallax>
  </div>
</template>

<script>
export default {
  name: 'BannerFooter',
}
</script>
